import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../utils/common'
import { AIButtonContainedDark } from '../../AIButton'
import { BUTTON_HEIGHT_40 } from '../../Button'
import { ICON_COLOR, ICON_HEIGHT_48, IconNG } from '../../Icon'
import Text from '../../Text'
import {
  QA_NAME_GRETA_AI_CHAT_LOCKED_STATE,
  QA_NAME_GRETA_AI_CHAT_LOCKED_SUPPORT,
} from '../GretaAIChat.constants'

import { getGretaAIChatSupportEmailLink } from './GretaAIChatLockedState.utils'

import * as styles from './GretaAIChatLockedState.module.css'

import GretaAvatar from '../../../icons/unique/ai/avatar.svg'

function GretaAIChatLockedState() {
  const { t } = useTranslation()

  const qaProps = getQaSelector({ value: QA_NAME_GRETA_AI_CHAT_LOCKED_STATE })

  return (
    <div {...qaProps} className={styles.root}>
      <div className={styles.scroll}>
        <div className={styles.content}>
          <IconNG
            Icon={GretaAvatar}
            className={styles.avatar}
            color={ICON_COLOR.Without}
            size={ICON_HEIGHT_48}
          />

          <Text Element='div' className={styles.heading}>
            {t('Greta.LockedHeadingKey')}
          </Text>
          <Text isSecondary Element='div' className={styles.description}>
            {t('Greta.LockedDescriptionKey')}
          </Text>
          <Text isSecondary Element='div' className={styles.access}>
            {t('Greta.LockedAccessKey')}
          </Text>

          <AIButtonContainedDark
            Element='a'
            className={styles.support}
            dataProps={{
              href: getGretaAIChatSupportEmailLink(
                t('Greta.LockedSupportSubjectKey')
              ),
            }}
            height={BUTTON_HEIGHT_40}
            qaName={QA_NAME_GRETA_AI_CHAT_LOCKED_SUPPORT}
            text={t('Greta.LockedSupportButtonKey')}
          />
        </div>
      </div>
    </div>
  )
}

export default GretaAIChatLockedState
